import { useEffect, useState } from "react";
import Button from "../UniversalComponents/DefaultButton";
import ReactTableComponent from "../UniversalComponents/ReactTableComponentCopy";
import * as XLSX from "xlsx";
import { detectColumnTypes, extractKeysFromObjects } from "../../utils/utilityFunctions/stringUtility";
import UploadCsvConfirmNameModal from "./UploadCsvConfirmNameModal";
import { mySpaceCsvUpload } from "../../utils/api/mySpaceApi";
import { pushAlert } from "../../utils/alertSlice";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useDispatch } from "react-redux";
// import ConfirmationDialog from "../UniversalComponents/ConfirmationDialogMulti";

const CsvUploadPreview = ({
  csvFileData,
  setCsvFileData,
  setShowCsvUploadPreview,
  currentDirectoryId,
  mySpaceDocumentList,
  showListView,
}) => {
  const [jsonData, setJsonData] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [columnTypes, setColumnTypes] = useState({});
  const [showCsvModalToUpload, setShowCsvModalToUpload] = useState(false);
  // const [showReuploadCsvModal, setShowReuploadCsvModal] = useState(false);
  const dispatch = useDispatch();

  const handleClosePreview = () => {
    setCsvFileData(null);
    setShowCsvUploadPreview(false);
  };

  const handleFileChange = async (e) => {
    setIsDataLoading(true);
    const file = csvFileData;
    if (!file) return;

    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(sheet, { raw: true });

      // if (json?.length > 1000 || Object.keys(json[0]).length > 50) {
      //   setShowReuploadCsvModal(true);
      // }

      setJsonData(json);
      setColumnTypes(detectColumnTypes(json));
      // setColumnTypes(inferColumnTypes(json));
    } catch (error) {
      console.error("Error reading file:", error);
    } finally {
      setIsDataLoading(false);
    }
  };

  const headerFormat = () => {
    return extractKeysFromObjects(jsonData || []).map((item, index) => {
      return {
        accessor_key: item,
        label: item,
      };
    });
  };

  const handleUploadCsv = async (tableName) => {
    try {
      const formData = new FormData();
      formData.append("file", csvFileData);
      formData.append("fieldTypes", JSON.stringify(columnTypes));
      formData.append("tableName", tableName);

      if (currentDirectoryId) {
        formData.append("parentId", currentDirectoryId);
      }

      const response = await mySpaceCsvUpload({ body: formData });
      if (response?.success) {
        dispatch(pushAlert({ type: "success", message: response?.message, visible: true }));
        handleClosePreview();
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.message, visible: true }));
      }
    } catch (error) {
      dispatch(pushAlert({ type: "danger", message: error?.message, visible: true }));
    }
  };

  // const handleReuploadCsv = () => {
  //   setShowReuploadCsvModal(false);
  // };

  // const reUploadModalHtml = () => {
  //   return (
  //     <>
  //       <table>
  //         <tbody>
  //           <tr>
  //             <td className="text-[#434852] text-[12px] text-600 font-semibold">Warning</td>
  //           </tr>
  //           <tr>
  //             {jsonData?.length > 1000 && (
  //               <td className="text-[#434852] text-[12px] text-600 font-semibold">
  //                 1000 Rows limit reached, Your file has <span>{jsonData?.length}</span> rows.
  //               </td>
  //             )}
  //             {Object.keys(jsonData[0]).length > 50 && (
  //               <td className="text-[#434852] text-[12px] text-600 font-semibold">
  //                 50 Columns limit reached, Your file has {Object.keys(jsonData[0]).length} columns.
  //               </td>
  //             )}
  //           </tr>
  //         </tbody>
  //       </table>
  //     </>
  //   )
  // }

  useEffect(() => {
    if (csvFileData) {
      handleFileChange();
    }
  }, []);

  return (
    <>
      <div className="p-4" style={{ display: showListView ? "none" : "block" }}>
        <p className="pt-2 pb-4 cursor-pointer text-[#1D4469]" onClick={handleClosePreview}>
          <ArrowBackIcon /> <span className="ms-2 font-semibold">Customise</span>
        </p>
        <ReactTableComponent
          tablename={
            <p className="text-[#434852] text-[12px] text-600 font-semibold">
              Choose the column types below and choose the new type if the current selection is incorrect.{" "}
            </p>
          }
          headers={headerFormat() || []}
          body={jsonData || []}
          isLoading={isDataLoading}
          columnTypes={columnTypes}
          setColumnTypes={setColumnTypes}
        />

        <div className="flex justify-end gap-4 mt-4">
          <div className="flex gap-2">
            <Button variant="primary" onClick={() => setShowCsvModalToUpload(true)}>
              Next
            </Button>
            <Button variant="secondary" onClick={handleClosePreview}>
              Cancel
            </Button>
          </div>
        </div>
      </div>

      <UploadCsvConfirmNameModal
        open={showCsvModalToUpload}
        onClose={() => setShowCsvModalToUpload(false)}
        handleCreate={handleUploadCsv}
      />

      {/* {showReuploadCsvModal && (
        <ConfirmationDialog
          open={showReuploadCsvModal}
          onConfirm={() => {
            handleReuploadCsv();
          }}
          onClose={() => setShowCsvModalToUpload(false)}
          title="Delete"
          message={reUploadModalHtml()}
          confirmVariant="delete"
          confirmText="Delete"
          cancelText="Cancel"
        />
      )} */}
    </>
  );
};

export default CsvUploadPreview;
